module.exports = __webpack_public_path__ + "media/images/products-img-01-f7150af0e8b63acd251dcb17fd8c11d3.jpg";